import { render, staticRenderFns } from "./HuaxianMenuDetail.vue?vue&type=template&id=d6f36138&scoped=true&"
import script from "./HuaxianMenuDetail.vue?vue&type=script&lang=js&"
export * from "./HuaxianMenuDetail.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianMenuDetail.vue?vue&type=style&index=0&id=d6f36138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f36138",
  null
  
)

export default component.exports